import {clsx} from 'clsx'
import {forwardRef} from 'react'

import styles from './borderless-text-input.module.css'

type StyledBorderLessTextInputProps = React.InputHTMLAttributes<HTMLInputElement>

export const BorderlessTextInput = forwardRef<HTMLInputElement, StyledBorderLessTextInputProps>(
  function BorderlessTextInput({className, ...props}, forwardedRef) {
    // A solution to make this component work without the interference of the wrapper of Primer's `TextInput`
    return <input {...props} ref={forwardedRef} className={clsx(styles.Box, className)} />
  },
)

BorderlessTextInput.displayName = 'BorderlessTextInput'
